import { visitorTypeDTOSchema, } from '@instanexus/contracts';
import { z } from 'zod';
import { dataEnvelopeSchema, WEB_API_PREFIX } from '../transport.js';
const visitorTypeListSchema = dataEnvelopeSchema(z.array(visitorTypeDTOSchema));
const singleVisitorTypeSchema = dataEnvelopeSchema(visitorTypeDTOSchema);
export function createVisitorTypesResource(transport) {
    return {
        async list(query) {
            const envelope = await transport.request({
                path: `${WEB_API_PREFIX}/visitor-types`,
                schema: visitorTypeListSchema,
                query: {
                    locationId: query?.locationId,
                    // ONLY ever sent when it is `true`. `visitorTypeListQuerySchema` parses this
                    // with `z.coerce.boolean()`, and `Boolean('false')` is `true` — so sending
                    // the literal string `false` would ask for exactly the opposite of what the
                    // caller meant. Omitting it lets the schema's own `.default(false)` answer.
                    includeInactive: query?.includeInactive === true ? true : undefined,
                },
            });
            return envelope.data;
        },
        async create(input) {
            const envelope = await transport.request({
                method: 'POST',
                path: `${WEB_API_PREFIX}/visitor-types`,
                schema: singleVisitorTypeSchema,
                body: input,
            });
            return envelope.data;
        },
        async update(id, input) {
            const envelope = await transport.request({
                method: 'PATCH',
                path: `${WEB_API_PREFIX}/visitor-types/${encodeURIComponent(id)}`,
                schema: singleVisitorTypeSchema,
                body: input,
            });
            return envelope.data;
        },
        async remove(id) {
            await transport.request({
                method: 'DELETE',
                path: `${WEB_API_PREFIX}/visitor-types/${encodeURIComponent(id)}`,
                schema: z.undefined(),
            });
        },
        async setVisibility(locationId, typeId, input) {
            const envelope = await transport.request({
                method: 'PUT',
                path: `${WEB_API_PREFIX}/locations/${encodeURIComponent(locationId)}/visitor-types/${encodeURIComponent(typeId)}/visibility`,
                schema: singleVisitorTypeSchema,
                body: input,
            });
            return envelope.data;
        },
    };
}
//# sourceMappingURL=visitor-types.js.map